var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack405({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.43,10.76l1.5-.16a1.3,1.3,0,0,0,.39.81,1,1,0,0,0,1.53-.09,1.77,1.77,0,0,0,.32-1.15,1.56,1.56,0,0,0-.32-1.09A1.1,1.1,0,0,0,8,8.72a1.53,1.53,0,0,0-1.16.57L5.61,9.11,6.39,5h4V6.43H7.53L7.29,7.77A2.3,2.3,0,0,1,10,8.24a2.67,2.67,0,0,1,.7,1.9,2.84,2.84,0,0,1-.57,1.74,2.5,2.5,0,0,1-2.13,1,2.65,2.65,0,0,1-1.78-.59A2.39,2.39,0,0,1,5.43,10.76Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "8 1 0.64 6.35 3.45 15 12.55 15 15.36 6.35 8 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack405);
export default __webpack_public_path__ + "static/media/Symbolpack_4_05.5a0fb96f5da548ca038ab91b5a713f97.svg";
export { ForwardRef as ReactComponent };